"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_1 = require("./styled");
var Photo = function (_a) {
    var src = _a.src, variant = _a.variant, alt = _a.alt, size = _a.size, width = _a.width, height = _a.height, onClick = _a.onClick, imgProps = tslib_1.__rest(_a, ["src", "variant", "alt", "size", "width", "height", "onClick"]);
    var w = width || size;
    var h = height || size;
    return (react_1.default.createElement(styled_1.PhotoImg, tslib_1.__assign({ src: src, alt: alt, width: w, height: h, onClick: onClick, variant: variant }, imgProps)));
};
Photo.defaultProps = {
    size: 100,
    variant: 'normal',
    alt: '',
};
exports.default = Photo;
//# sourceMappingURL=index.js.map